import React from 'react';
import { Box, Card, ListItemButton, ListItemText } from '@mui/material';
import { useTheme } from '@mui/system';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { lighten } from '@mui/material/styles';

import Chip from '../Chip';
import ItemAvatar from './ItemAvatar';

interface ItemCreationCardProps {
  icon: React.ElementType;
  titleId: string;
  descriptionId?: string;
  steps?: number;
  to?: string;
  onClick?: () => void;
}

function PostCreationCard({
  icon: Icon,
  titleId,
  descriptionId,
  steps,
  to,
  onClick,
}: ItemCreationCardProps) {
  const theme = useTheme();
  const intl = useIntl();

  return (
    <Card
      variant="outlined"
      sx={{
        mb: 1,
        borderColor: lighten(theme.palette.secondary.main, 0.8),
        borderRadius: 3,
      }}
    >
      <ListItemButton
        {...(to && { component: Link, to })}
        {...(onClick && { onClick })}
        sx={{
          '&:hover': { bgcolor: lighten(theme.palette.secondary.main, 0.93) },
          p: 2,
          gap: 1,
        }}
      >
        <ItemAvatar icon={Icon} />

        <ListItemText
          primary={intl.formatMessage({
            id: titleId,
          })}
          {...(descriptionId && { secondary: intl.formatMessage({ id: descriptionId }) })}
        />

        {steps && (
          <Box sx={{ alignSelf: 'flex-start' }}>
            <Chip
              label={intl.formatMessage(
                {
                  id: `POSTS.CREATE_MENU.STEPS_COUNT`,
                },
                { count: steps },
              )}
              sx={{ borderRadius: 5 }}
              color="secondary"
              size="small"
              variant="outlined"
            />
          </Box>
        )}
      </ListItemButton>
    </Card>
  );
}

export default PostCreationCard;
